import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanUpdateWorkflows = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const updatePermissionAll: UserPermission = {
    resource: 'workflows',
    action: 'updatebasic',
    scope: 'all',
  };

  const canUpdateAll = useHasPermission(user, updatePermissionAll);
  return canUpdateAll;
};
